import Swiper from 'swiper';
import {Autoplay, EffectFade} from 'swiper/modules';
import 'swiper/swiper-bundle.css';

const sliderInit = () => document.querySelectorAll('[data-slider]').forEach(slider => {

    if (slider.hasAttribute('data-slider-init')) return
    slider.setAttribute('data-slider-init', true)

    const options = {
      modules: [EffectFade, Autoplay],
      loop: true,
      autoHeight: true,
      allowTouchMove: false,
      slidesPerView: 1,
      autoplay: {
        delay: 2000,
      },
      speed: 1000,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
    }

    const swiper = new Swiper(slider.querySelector('.swiper'), options);
  }
)

window.addEventListener('page:update', e => sliderInit())
sliderInit()
